import { render, staticRenderFns } from "./LibTableSpecialty1.vue?vue&type=template&id=67768980&scoped=true"
import script from "./LibTableSpecialty1.vue?vue&type=script&lang=js"
export * from "./LibTableSpecialty1.vue?vue&type=script&lang=js"
import style0 from "./LibTableSpecialty1.vue?vue&type=style&index=0&id=67768980&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67768980",
  null
  
)

export default component.exports